<mat-dialog-content class="text-center">
    <div class="container-popup">
        <div class="header">
            <span class="header-title">{{existingCourt ? 'Update' : 'Create'}} Court</span>
            <span class="header-close">
                <button mat-icon-button (click)="onNoClick()" style="position: absolute; right: 10px; top: 10px;">
                    <mat-icon>close</mat-icon>
                </button>
            </span>
        </div>

        <form #formData="ngForm">
            <div>
                <div class="field">
                    <label for="courtname">Division / Court Name</label>
                    <input id="courtname" pInputText class="w-full" type="text" name="courtname"
                        placeholder="Enter court name" [(ngModel)]="court.name" maxlength="50"  required #courtname="ngModel">
                        <small *ngIf="courtname.invalid && (courtname.dirty || courtname.touched)" style="color: red;">
                            <div *ngIf="courtname.errors?.['required']" style="color: red;">*Courtname is required</div>
                        </small>
                </div>

                <div class="field">
                    <label for="address1">Address 1</label>
                    <input id="address1" pInputText class="w-full" type="text" name="address1"
                        placeholder="Enter court address 1" [(ngModel)]="court.address1" maxlength="250"  required #address="ngModel" >
                        <small *ngIf="address.invalid && (address.dirty || address.touched)" style="color: red;">
                            <div *ngIf="address.errors?.['required']" style="color: red;">*Address is required</div>
                        </small>
                </div>

                <div class="field">
                    <label for="address2">Address 2</label>
                    <input id="address2" pInputText class="w-full" type="text" name="address2" maxlength="250"
                        placeholder="Enter court address 2" [(ngModel)]="court.address2" >
                </div>

                <div class="field">
                    <label for="city">City</label>
                    <input id="city" pInputText class="w-full" type="text" name="city" placeholder="Enter court city" maxlength="100"
                        [(ngModel)]="court.city" required pattern="[A-Za-z,0-9 ]*" #city="ngModel">
                    <small *ngIf="city.invalid && (city.dirty||city.touched)" style="color: red;">
                        <div *ngIf="city.errors?.['pattern']" style="color: red;">*Enter valid Cityname</div>
                        <div *ngIf="city.errors?.['required']" style="color: red;">*City is required</div>
                    </small>
                </div>

                <div class="field">
                    <label for="state">State</label>
                    <select id="state" name="state" [(ngModel)]="court.state.id" required class="w-full" #state="ngModel">
                        <option [value]="-1" disabled>Select State</option>
                        <option *ngFor="let s of states" [value]="s.id">{{s.code}} - {{s.name}}</option>
                    </select>
                    <small *ngIf="court.state.id === -1 && state.touched" style="color: red;">
                        * State is required
                    </small>
                </div>

                <div class="field">
                    <label for="zip">Zip</label>
                    <input id="zip" pInputText class="w-full" type="text"  name="zip" placeholder="Enter court Zip"
                        [(ngModel)]="court.zip" #zip="ngModel" required  pattern="^\d{5}$" maxlength="5" 
                        [value]="court.zip === '0' ? '' : court.zip">
                        <small *ngIf="zip.invalid && (zip.dirty || zip.touched)" class="small-error">
                            <div *ngIf="zip.errors?.['pattern']" style="color: red;">*Enter valid 5 digit zip</div>
                            <div *ngIf="zip.errors?.['required']" style="color: red;">*Zipcode is required</div>
                        </small>
                </div>
                <div class="field">
                    <label for="sport">Sport</label>
                    <select id="sport" name="sport" [(ngModel)]="court.sport.id" required placeholder="Select Sport"
                        class="w-full" #sport="ngModel">
                        <option value="-1" disabled selected>Select Sport</option>
                        <option *ngFor="let sport of sports" value="{{sport.id}}">{{sport.name}}</option>
                    </select>
                    <small *ngIf="court.sport.id === -1 && sport.dirty" style="color: red;">
                        * Sport is required
                    </small>
                </div>
                <div class="field">
                    <label for="">Court Features</label>
                </div>
                <div class="flex gap-3 mt-2">
                    <!-- Is Public -->
                    <button
                      class="px-3 py-1 rounded-md text-sm font-medium flex items-center gap-1 transition duration-200"
                      [ngClass]="court.isPublic ? 'bg-blue-600 text-white border border-blue-400' : 'bg-gray-800 text-gray-300 border border-gray-600'"
                      (click)="court.isPublic = !court.isPublic">
                      <span>Is Public</span>
                      <span *ngIf="court.isPublic" class="text-white text-sm">✔</span>
                    </button>
                  
                    <!-- Has Indoor -->
                    <button
                      class="px-3 py-1 rounded-md text-sm font-medium flex items-center gap-1 transition duration-200"
                      [ngClass]="court.hasIndoor ? 'bg-blue-600 text-white border border-blue-400' : 'bg-gray-800 text-gray-300 border border-gray-600'"
                      (click)="court.hasIndoor = !court.hasIndoor">
                      <span>Has Indoor</span>
                      <span *ngIf="court.hasIndoor" class="text-white text-sm">✔</span>
                    </button>
                  
                    <!-- Is Club -->
                    <button
                      class="px-3 py-1 rounded-md text-sm font-medium flex items-center gap-1 transition duration-200"
                      [ngClass]="court.isClub ? 'bg-blue-600 text-white border border-blue-400' : 'bg-gray-800 text-gray-300 border border-gray-600'"
                      (click)="court.isClub = !court.isClub">
                      <span>Is Club</span>
                      <span *ngIf="court.isClub" class="text-white text-sm">✔</span>
                    </button>
                  </div>
                  
                  
                <div class="field">
                    <label for="">Number of Courts</label>
                    <input id="noofcourts" pInputText class="w-full" type="number" name="courtno" placeholder="Enter Number Of Court"
                       [(ngModel)]="court.numberOfCourt" (change)="onNumberOfCourtChange()" min="1" max="20" maxlength="2" pattern="[0-9]*"  required #noofcourts="ngModel">
    
                    <small *ngIf="noofcourts.errors?.['required'] && (noofcourts.dirty || noofcourts.touched)" style="color: red;">
                      *Number of courts required
                    </small>
                    <small *ngIf="court.numberOfCourt !== null && court.numberOfCourt <= 0 && !noofcourts.errors?.['required']" style="color: red;">
                      * Number of courts must be greater than 0
                    </small>
                </div>
                <div class="mb-3 text-end">
                    <button type="button" class="registerBtn create-btn" [disabled]="formData.invalid || court.numberOfCourt === 0 || court.state.id === -1 || court.sport.id === -1"
                        (click)="dialogRef.close(court);">
                        <span><mat-icon>check</mat-icon></span>
                        <span>{{existingCourt ? 'Update' : 'Create'}}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</mat-dialog-content>